import { render, staticRenderFns } from "./ContractsPriceChanges.vue?vue&type=template&id=1dd57454"
import script from "./ContractsPriceChanges.vue?vue&type=script&lang=js"
export * from "./ContractsPriceChanges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports